import * as React from 'react';

function IconGol() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#FF7021" />
      <path
        d="M17.3722 8.56055C16.9033 8.56055 16.4446 8.60418 15.9999 8.68682C19.4464 9.33117 22.0554 12.0924 22.0554 15.7264C22.0554 18.3132 19.9589 20.6715 17.3722 20.6715C16.895 20.6715 16.4344 20.6 15.9999 20.4672C14.0826 19.8804 12.689 18.0977 12.689 15.9883C12.689 13.8788 14.0836 12.0961 15.9999 11.5094C15.5663 11.3766 15.1049 11.3051 14.6276 11.3051C12.0409 11.3051 9.94446 13.6643 9.94446 16.2501C9.94446 19.8832 12.5534 22.6454 15.9999 23.2888C16.4446 23.3714 16.9033 23.4151 17.3722 23.4151C21.4741 23.4151 24.7999 20.0893 24.7999 15.9873C24.7999 11.8854 21.4741 8.56055 17.3722 8.56055Z"
        fill="#F3A677"
      />
      <path
        d="M14.6277 8.57227C15.0966 8.57227 15.5552 8.6159 16 8.69854C19.4464 9.34289 22.0554 12.1041 22.0554 15.7382C22.0554 18.3249 19.9589 20.6832 17.3722 20.6832C16.895 20.6832 16.4335 20.6117 16 20.4789C17.9172 19.8921 19.3109 18.1085 19.3109 16C19.3109 13.8905 17.9163 12.1079 16 11.5211C15.5654 11.3883 15.1049 11.3168 14.6277 11.3168C12.041 11.3168 9.9445 13.676 9.9445 16.2618C9.9445 19.8949 12.5535 22.6571 16 23.3005C15.5552 23.3841 15.0966 23.4277 14.6277 23.4277C10.5257 23.4277 7.19995 20.102 7.19995 16C7.19995 11.898 10.5257 8.57227 14.6277 8.57227Z"
        fill="white"
      />
    </svg>
  );
}

export default IconGol;
